/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Validation_Bank_Code_DigitsInputs */

const en_clients_validation_bank_code_digits = /** @type {(inputs: Clients_Validation_Bank_Code_DigitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bank code must contain only numbers.`)
};

const pt_br2_clients_validation_bank_code_digits = /** @type {(inputs: Clients_Validation_Bank_Code_DigitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código do banco deve conter apenas números.`)
};

/**
* | output |
* | --- |
* | "Bank code must contain only numbers." |
*
* @param {Clients_Validation_Bank_Code_DigitsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_bank_code_digits = /** @type {((inputs?: Clients_Validation_Bank_Code_DigitsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_Bank_Code_DigitsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_bank_code_digits(inputs)
	return pt_br2_clients_validation_bank_code_digits(inputs)
});